module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAARhJREFUSEtj/P//PzMDDQEjXS2Q2vPB/9ff/7n/GRgMGBkYBMjw2AEWRqbmF278B2F64T6AGr6WDEMxtAAtcYZZArdAZMf7vQyMDPZA14MB0AckARR9/xkOvvEQdAabA4sDkZ3v/4AEQApJNRzmEpheIP3hrbugCFYLSHI2HsVv3AVZSLZgoxkvw3+g8wJOfyboDrIsAGoCGwwMzlELICEACnNrSFzhBEfe/cEaJ0TFATEWHAWmbv9TmJFOlAXozh6NZHBRgQ+A4gQEsIU5luAkPScTcgCyPM5IplJh9xFY2AmjlkXQ4hokSI4lKHqwFdc0r3BALgdb8ud/3n9GcJXJT0qYg9UCXc7CxNSEtcok2TAiNdC8VQEAV4zjGbMA2m4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/more_active.png
// module id = CCSY
// module chunks = 9